import queryString from 'querystring'
import uuid from 'uuid/v1'
import api from '../api'

export const SESSION_UPDATE = 'SESSION_UPDATE'

export const updateSession = (session) => ({type: SESSION_UPDATE, session})

const camelCase = s => s.replace(/_([a-z])/g, g => g[1].toUpperCase())
const queryParam = (p, {queryParams: params}) => params[p] ? params[p] : null

export function getDateTime() {
  const date = new Date()
  return date.toISOString().slice(0, 19).replace('T', ' ')
}

function getQueryParams() {
  const params = window.location.search.substr(1)
  return queryString.parse(params)
}

function waitForClientId() {
  let numberOfTries = 0
  return new Promise((resolve, reject) => {
    function getClientId() {
      const counter = window.yaCounter52249555 || null
      if (counter && counter.getClientID) {
        resolve(counter.getClientID())
      } else if (numberOfTries++ < 50) {
        setTimeout(getClientId, 200)
      } else {
        resolve(null)
      }
    }
    getClientId()
  })
}

function utmExtra({queryParams}) {
  return Object.getOwnPropertyNames(queryParams)
    .filter(param => param.startsWith('utm_') && param !== 'utm_campaign')
    .reduce((r, p) => (r[camelCase(p)] = queryParams[p], r), {})
}

function makeSession({session, geolocation}) {
  return {
    id: session.id,
    datetime: session.datetime,
    clientId: session.clientId,
    utmCampaign: queryParam('utm_campaign', session),
    utmExtra: utmExtra(session)
  }
}

export function initSession() {
  return (dispatch, getState) => {
    const session = {
      id: uuid(),
      datetime: getDateTime(),
      queryParams: getQueryParams()
    }
    dispatch(updateSession(session))
    waitForClientId().then(clientId => {
      const session = {clientId}
      dispatch(updateSession(session))
      api.sessions.send(makeSession(getState()))
        .then(response => response.json())
        .then(console.log)
    })
  }
}



// WEBPACK FOOTER //
// ./actions/session.js